import BaseView from '../../core/baseView';

export default BaseView.extend({
  events: {
    'submit .takeorder': 'onFormSubmit'
  },

  wasFormSend: false,

  onFormSubmit: function() {
    if (this.wasFormSend) {
      return false;
    }
    this.wasFormSend = true;

    return true;
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/indexView.js
 **/